import { Currency } from '../enum/currency'
import { applyEntitySchema, sourceJson } from '../../_utils/fcdc-v2'
import { rateSchema } from '../schema/pricing.schema'

export class Rate {
  priceCategoryName: string
  priceCategoryId: string
  currency: Currency
  pricePerAllocatedHour: string
  pricePerUnallocatedHour: string
  pricePerRollingHour: string

  constructor(json: any) {
    const source = sourceJson(json) as any
    this.priceCategoryName = source.priceCategoryName
    this.priceCategoryId = source.priceCategoryId
    this.currency = source.currency
    this.pricePerAllocatedHour = source.pricePerAllocatedHour
    this.pricePerUnallocatedHour = source.pricePerUnallocatedHour
    this.pricePerRollingHour = source.pricePerRollingHour
    applyEntitySchema(this, rateSchema, source, {})
  }
}
